export default __webpack_public_path__ + "static/media/4.094f7bca.png";